// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: "Roboto";
}

.sidebar {
  width: 260px;
  height:150vh;
  background-color: #396d72;
  position: fixed;
  top: 56px;
  left: 0;
  padding-top: 20px;
}

.sidebar .nav-link {
  color: #ecf0f1;
  padding: 10px 20px;
}

.sidebar .nav-link.active {
  color: white;
}

.sidebar .nav-link:hover {
  background-color: black;
  border-radius: 10px;
}

/* Offcanvas Menu */
.two {
  background-color: #396d72;
  color: #fff;
}

.two .nav-link {
  color: #fff;
}
/* 
.two .nav-link:hover {
  background-color: black;
  border-radius: 10px;
} */

/* Content Styling */
.content {
  margin-left: 250px;
  margin-top: 60px;
  padding: 20px;
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 15px;
  /* border-bottom: 2px solid #ccc; */
}

.create-btn {
  background-color: #396d72;
  border: none;
}

.create-btn:hover {
  background-color: #396d72;
}

/* Logo Container */
.logo-container {
  width: 150px;
  height: 100px;
  border-radius: 10px;
  overflow: hidden;
  padding-top: 10px;
  border:'1px solid red'
}

.logo-container img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Table Responsiveness */
/* .table-container {
  width: 100%;
  overflow-x: auto;
}



.custom-table {
  min-width: 800px;
} */

/* Add this to your CSS file or inline styles as needed */

/* navbar fixed*/
/* .fixed-navbar {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1050;
}

.fixed-sidebar {
  position: fixed;
  top: 56px; 
  bottom: 0;
  overflow-y: auto;
  height: calc(100vh - 56px);
}

.scrollable-content {
  margin-top: 56px; 
  margin-left: 25%; 
  height: calc(100vh - 56px);
  overflow-y: auto;
  padding: 20px;
} */

/* ================================ */

/* remove arrows */
/* Hide arrows for number inputs */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

input::placeholder {
  color: #fff !important;
  opacity: 1; /* Optional: ensures the color is solid */
}

.login_page input::placeholder {
  color: #000000 !important;
  opacity: 1;
}

/* ===== */

/* table {
  overflow-x: auto;
  
  width: 100%;
  border-collapse:separate;
 
  margin-bottom: 20px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
  background-color: #C5CACF;
  border-radius: 5px;
  overflow: hidden;
}

th,
td {
  padding: 12px 15px;
  text-align: left;
  



}

th:not(:last-child),
td:not(:last-child) {
  border-right: 1px solid black;

}

th {

  border-bottom: 1px solid #181717;

}

@media screen and (max-width: 600px) {
  table {
    border: 0;
  }

  thead {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  tr {
    
    display: block;
    margin-bottom: 0.625em;


  }

  td {
  
    display: block;
    text-align: right;
    padding-left: 50%;
  
  }

  td::before {
    
    position: absolute;
    top: 6px;
    left: 6px;
    width: 45%;
    
    padding-right: 10px;
    white-space: nowrap;
    content: attr(data-label);
    text-align: left;
    font-weight: bold;
  }
}

tbody {
  border-right: 1px solid #35646E;


} */

/* ==================================== */
tbody,
thead {
  border-right: 1px solid black;
}

.custom-offcanvas-header .btn-close {
  filter: brightness(0) invert(1); /* Makes black icon white */
}

/* ///check boxxxxx */
.transparent-checkbox .form-check-input {
  background-color: transparent !important;
  border: 2px solid #fff !important;
  box-shadow: none !important;
  /* width: 20px;
  height: 20px; */
  margin-right: 8px;
  /* padding: 8px; */
}

.transparent-checkbox .form-check-input:checked {
  background-color: transparent !important;
  border-color: #fff !important;
  background-image: none !important;
  position: relative;
}

.transparent-checkbox .form-check-input:checked::before {
  content: "✔";
  color: white;
  position: absolute;
  left: 2px;
  top: -2px;
  font-size: 15px;
  line-height: 1;
}
/* ///////////////////////////////////////// */
/* Fix modal height and allow scroll only inside the image container */
/* .modal-fixed-image-scroll .modal-content {
  max-height: 80vh;
  overflow: hidden;
  border-radius: 10px;
}


.image-scroll-container {
  overflow-y: auto;
  max-height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
}


.scrollable-image {
  max-width: 100%;
  height: auto;
  object-fit: contain;
} 



/* ///////////////////////////// */

.modal-halfscreen {
  max-width: 70% !important;
  width: 70%;
}
.large-modal {
  max-width: 90% !important;
  width: 90%;
  /* background-color: rgba(rgba(128, 128, 128, 0.432)); */
}

.collapsible {
  max-height: 0;
  overflow: auto;
  transition: max-height 0.4s ease;
  text-align: left;
  max-width: 200px;
}

.collapsible.open {
  max-height: 120px; /* Adjust depending on content */
}

/* Webkit Browsers (Chrome, Edge, Safari) */
.collapsible::-webkit-scrollbar {
  width: 4px; /* Width of the scrollbar */
}

.collapsible::-webkit-scrollbar-track {
  background: #f1f1f1; /* Track color */
  border-radius: 8px;
}

.collapsible::-webkit-scrollbar-thumb {
  background: #abaaaa; /* Scrollbar thumb color */
  border-radius: 4px;
}

.collapsible::-webkit-scrollbar-thumb:hover {
  background: #555; /* On hover */
}


@media (max-width: 991px) {
  .content {
    margin-left: 0;
  }
  .transparent-checkbox .form-check-input {
    /* width: 15px;
     height: 15px; */
  }
  .apply_button button {
    font-size: 10px;
    font-weight: 500;
    font-family: "Roboto";
  }
}

@media (min-width: 770px) {
  .text-centere {
    position: absolute;
    top: 50%;
    left: 60%;
    transform: translate(-50%, -50%);
  }
}

@media (max-width: 769px) {
  .text-centere {
    /* position: absolute; */
    /* top: 50%;
    left: 60%; */
    /* transform: translate(-50%, -50%); */
    margin-top: 50%;
    margin-right: 20%;
  }
  .address {
    margin-top: 50%;
  }
  
}

@media (max-width: 991px) {
  .cards p {
    line-height: 0;
    font-size: 14px;
  }
}

@media (max-width: 360px) {
  .cards {
    line-height: 0;
    font-size: 5px;
  }
  .hamsburg{
    position: relative;
    /* right: 70px; */
  }
}

@media only screen and (min-width: 1024px) and (max-width: 1366px) {
  /* Your laptop-specific styles here */
  .cart_weight{
    margin-top: 10px;
    margin-left: 21%;
    
  }
  .Add_cart{
    margin-left: 20%;
    align-items: center;
  }
  }

  @media only screen and (min-width: 767px){

  }

  @media only screen and (min-width: 600px) and (max-width: 1023px){
    .cart_weight{
      margin-top: 10px;
      margin-left: 30%;
    }
    .Add_cart{
      margin-left: 20%;
      align-items: center;
    }
  }

  
@media (max-width: 450px) {
  .home {
    display: none;
  }
  .cart{
    position: relative;
    left: 0%;
  } 
  .hamsburg{
    position: relative;
    right: 20%;
  }
  @media (max-width: 450px) {
  .home {
    display: none;
  }
  .cart{
    position: relative;
    left: 0%;
  } 
  .hamsburg{
    position: relative;
    right: 20%;
  }

}
}
@media (max-width: 450px) {
  .home {
    display: none;
  }
  .cart{
    position: relative;
    left: 0%;
  } 
  .hamsburg{
    position: relative;
    right: 20%;
  }
  @media (min-width: 450px) {
  .home {
    display: none;
  }
  .cart{
    position: relative;
    left: 200%;
  } 
  .hamsburg{
    position: relative;
    right: 20%;
  }

}
}

@media (max-width: 430px) {
  .home {
    display: none;
  }
  .cart{
    position: relative;
    left: 200%;
  } 
  .hamsburg{
    position: relative;
    right: 20%;
  }

}


@media (max-width: 748px) {

  /* .cart{
    position: relative;
    left: 2px;
  }
  .hamsburg{
    position: relative;
    right: 30px;
  } */
  .card_name{
    display:'none'
  }
}
@media(max-width:666px){
  .cart_items{
    margin-top: 75px;
  }
}
@media(max-width:1024px){
  .card_name{
   display:'none';
  }
  
}

@media(max-width:320px){
  .cart_items{
    margin-top: 65px;
  }
  .cart{
    position: relative;
    left: 170%;
  } 
  .hamsburg{
    position: relative;
    right: 20%;
  }
}

@media(max-width:415px){
  .header-section{
    margin-top: 130px;
  }
}
@media (min-width: 992px) {
  .content {
    margin-top: -100px !important;
    /* Ensure content starts right below navbar */
    padding-top: 20px;
    /* Just enough spacing for aesthetics */
  }
}

@media (min-width: 903px) {
  .button button {
    font-size: "10px";
  }
}`, "",{"version":3,"sources":["webpack://./src/style/admin.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,SAAS;EACT,OAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;AACA;;;;GAIG;;AAEH,oBAAoB;AACpB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;;;;;;;;;GASG;;AAEH,yDAAyD;;AAEzD,gBAAgB;AAChB;;;;;;;;;;;;;;;;;;;;;GAqBG;;AAEH,qCAAqC;;AAErC,kBAAkB;AAClB,kCAAkC;AAClC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,UAAU,EAAE,yCAAyC;AACvD;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA,UAAU;;AAEV;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAsFG;;AAEH,yCAAyC;AACzC;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B,EAAE,2BAA2B;AAC9D;;AAEA,qBAAqB;AACrB;EACE,wCAAwC;EACxC,iCAAiC;EACjC,2BAA2B;EAC3B;iBACe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,6BAA6B;EAC7B,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,eAAe;EACf,cAAc;AAChB;AACA,8CAA8C;AAC9C,sEAAsE;AACtE;;;;;;;;;;;;;;;;;;;;;;;;kCAwBkC;;AAElC;EACE,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,UAAU;EACV,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB,EAAE,gCAAgC;AACrD;;AAEA,2CAA2C;AAC3C;EACE,UAAU,EAAE,2BAA2B;AACzC;;AAEA;EACE,mBAAmB,EAAE,gBAAgB;EACrC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB,EAAE,0BAA0B;EAC/C,kBAAkB;AACpB;;AAEA;EACE,gBAAgB,EAAE,aAAa;AACjC;;;AAGA;EACE;IACE,cAAc;EAChB;EACA;IACE;oBACgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB;gBACY;IACZ,sCAAsC;IACtC,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;;AAEF;;AAEA;EACE;IACE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;IACd,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE,qCAAqC;EACrC;IACE,gBAAgB;IAChB,gBAAgB;;EAElB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;;EAEA;;EAEA;;EAEA;IACE;MACE,gBAAgB;MAChB,gBAAgB;IAClB;IACA;MACE,gBAAgB;MAChB,mBAAmB;IACrB;EACF;;;AAGF;EACE;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,QAAQ;EACV;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;EACA;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,QAAQ;EACV;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;;AAEF;AACA;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,QAAQ;EACV;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;EACA;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;;AAEF;AACA;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;;AAEF;;;AAGA;;EAEE;;;;;;;KAOG;EACH;IACE;EACF;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;GACC,cAAc;EACf;;AAEF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,6BAA6B;IAC7B,6CAA6C;IAC7C,iBAAiB;IACjB,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":["* {\n  font-family: \"Roboto\";\n}\n\n.sidebar {\n  width: 260px;\n  height:150vh;\n  background-color: #396d72;\n  position: fixed;\n  top: 56px;\n  left: 0;\n  padding-top: 20px;\n}\n\n.sidebar .nav-link {\n  color: #ecf0f1;\n  padding: 10px 20px;\n}\n\n.sidebar .nav-link.active {\n  color: white;\n}\n\n.sidebar .nav-link:hover {\n  background-color: black;\n  border-radius: 10px;\n}\n\n/* Offcanvas Menu */\n.two {\n  background-color: #396d72;\n  color: #fff;\n}\n\n.two .nav-link {\n  color: #fff;\n}\n/* \n.two .nav-link:hover {\n  background-color: black;\n  border-radius: 10px;\n} */\n\n/* Content Styling */\n.content {\n  margin-left: 250px;\n  margin-top: 60px;\n  padding: 20px;\n}\n\n.header-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 15px;\n  /* border-bottom: 2px solid #ccc; */\n}\n\n.create-btn {\n  background-color: #396d72;\n  border: none;\n}\n\n.create-btn:hover {\n  background-color: #396d72;\n}\n\n/* Logo Container */\n.logo-container {\n  width: 150px;\n  height: 100px;\n  border-radius: 10px;\n  overflow: hidden;\n  padding-top: 10px;\n  border:'1px solid red'\n}\n\n.logo-container img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n/* Table Responsiveness */\n/* .table-container {\n  width: 100%;\n  overflow-x: auto;\n}\n\n\n\n.custom-table {\n  min-width: 800px;\n} */\n\n/* Add this to your CSS file or inline styles as needed */\n\n/* navbar fixed*/\n/* .fixed-navbar {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 1050;\n}\n\n.fixed-sidebar {\n  position: fixed;\n  top: 56px; \n  bottom: 0;\n  overflow-y: auto;\n  height: calc(100vh - 56px);\n}\n\n.scrollable-content {\n  margin-top: 56px; \n  margin-left: 25%; \n  height: calc(100vh - 56px);\n  overflow-y: auto;\n  padding: 20px;\n} */\n\n/* ================================ */\n\n/* remove arrows */\n/* Hide arrows for number inputs */\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\ninput::placeholder {\n  color: #fff !important;\n  opacity: 1; /* Optional: ensures the color is solid */\n}\n\n.login_page input::placeholder {\n  color: #000000 !important;\n  opacity: 1;\n}\n\n/* ===== */\n\n/* table {\n  overflow-x: auto;\n  \n  width: 100%;\n  border-collapse:separate;\n \n  margin-bottom: 20px;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);\n  background-color: #C5CACF;\n  border-radius: 5px;\n  overflow: hidden;\n}\n\nth,\ntd {\n  padding: 12px 15px;\n  text-align: left;\n  \n\n\n\n}\n\nth:not(:last-child),\ntd:not(:last-child) {\n  border-right: 1px solid black;\n\n}\n\nth {\n\n  border-bottom: 1px solid #181717;\n\n}\n\n@media screen and (max-width: 600px) {\n  table {\n    border: 0;\n  }\n\n  thead {\n    border: none;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px;\n  }\n\n  tr {\n    \n    display: block;\n    margin-bottom: 0.625em;\n\n\n  }\n\n  td {\n  \n    display: block;\n    text-align: right;\n    padding-left: 50%;\n  \n  }\n\n  td::before {\n    \n    position: absolute;\n    top: 6px;\n    left: 6px;\n    width: 45%;\n    \n    padding-right: 10px;\n    white-space: nowrap;\n    content: attr(data-label);\n    text-align: left;\n    font-weight: bold;\n  }\n}\n\ntbody {\n  border-right: 1px solid #35646E;\n\n\n} */\n\n/* ==================================== */\ntbody,\nthead {\n  border-right: 1px solid black;\n}\n\n.custom-offcanvas-header .btn-close {\n  filter: brightness(0) invert(1); /* Makes black icon white */\n}\n\n/* ///check boxxxxx */\n.transparent-checkbox .form-check-input {\n  background-color: transparent !important;\n  border: 2px solid #fff !important;\n  box-shadow: none !important;\n  /* width: 20px;\n  height: 20px; */\n  margin-right: 8px;\n  /* padding: 8px; */\n}\n\n.transparent-checkbox .form-check-input:checked {\n  background-color: transparent !important;\n  border-color: #fff !important;\n  background-image: none !important;\n  position: relative;\n}\n\n.transparent-checkbox .form-check-input:checked::before {\n  content: \"✔\";\n  color: white;\n  position: absolute;\n  left: 2px;\n  top: -2px;\n  font-size: 15px;\n  line-height: 1;\n}\n/* ///////////////////////////////////////// */\n/* Fix modal height and allow scroll only inside the image container */\n/* .modal-fixed-image-scroll .modal-content {\n  max-height: 80vh;\n  overflow: hidden;\n  border-radius: 10px;\n}\n\n\n.image-scroll-container {\n  overflow-y: auto;\n  max-height: 70vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n\n.scrollable-image {\n  max-width: 100%;\n  height: auto;\n  object-fit: contain;\n} \n\n\n\n/* ///////////////////////////// */\n\n.modal-halfscreen {\n  max-width: 70% !important;\n  width: 70%;\n}\n.large-modal {\n  max-width: 90% !important;\n  width: 90%;\n  /* background-color: rgba(rgba(128, 128, 128, 0.432)); */\n}\n\n.collapsible {\n  max-height: 0;\n  overflow: auto;\n  transition: max-height 0.4s ease;\n  text-align: left;\n  max-width: 200px;\n}\n\n.collapsible.open {\n  max-height: 120px; /* Adjust depending on content */\n}\n\n/* Webkit Browsers (Chrome, Edge, Safari) */\n.collapsible::-webkit-scrollbar {\n  width: 4px; /* Width of the scrollbar */\n}\n\n.collapsible::-webkit-scrollbar-track {\n  background: #f1f1f1; /* Track color */\n  border-radius: 8px;\n}\n\n.collapsible::-webkit-scrollbar-thumb {\n  background: #abaaaa; /* Scrollbar thumb color */\n  border-radius: 4px;\n}\n\n.collapsible::-webkit-scrollbar-thumb:hover {\n  background: #555; /* On hover */\n}\n\n\n@media (max-width: 991px) {\n  .content {\n    margin-left: 0;\n  }\n  .transparent-checkbox .form-check-input {\n    /* width: 15px;\n     height: 15px; */\n  }\n  .apply_button button {\n    font-size: 10px;\n    font-weight: 500;\n    font-family: \"Roboto\";\n  }\n}\n\n@media (min-width: 770px) {\n  .text-centere {\n    position: absolute;\n    top: 50%;\n    left: 60%;\n    transform: translate(-50%, -50%);\n  }\n}\n\n@media (max-width: 769px) {\n  .text-centere {\n    /* position: absolute; */\n    /* top: 50%;\n    left: 60%; */\n    /* transform: translate(-50%, -50%); */\n    margin-top: 50%;\n    margin-right: 20%;\n  }\n  .address {\n    margin-top: 50%;\n  }\n  \n}\n\n@media (max-width: 991px) {\n  .cards p {\n    line-height: 0;\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 360px) {\n  .cards {\n    line-height: 0;\n    font-size: 5px;\n  }\n  .hamsburg{\n    position: relative;\n    /* right: 70px; */\n  }\n}\n\n@media only screen and (min-width: 1024px) and (max-width: 1366px) {\n  /* Your laptop-specific styles here */\n  .cart_weight{\n    margin-top: 10px;\n    margin-left: 21%;\n    \n  }\n  .Add_cart{\n    margin-left: 20%;\n    align-items: center;\n  }\n  }\n\n  @media only screen and (min-width: 767px){\n\n  }\n\n  @media only screen and (min-width: 600px) and (max-width: 1023px){\n    .cart_weight{\n      margin-top: 10px;\n      margin-left: 30%;\n    }\n    .Add_cart{\n      margin-left: 20%;\n      align-items: center;\n    }\n  }\n\n  \n@media (max-width: 450px) {\n  .home {\n    display: none;\n  }\n  .cart{\n    position: relative;\n    left: 0%;\n  } \n  .hamsburg{\n    position: relative;\n    right: 20%;\n  }\n  @media (max-width: 450px) {\n  .home {\n    display: none;\n  }\n  .cart{\n    position: relative;\n    left: 0%;\n  } \n  .hamsburg{\n    position: relative;\n    right: 20%;\n  }\n\n}\n}\n@media (max-width: 450px) {\n  .home {\n    display: none;\n  }\n  .cart{\n    position: relative;\n    left: 0%;\n  } \n  .hamsburg{\n    position: relative;\n    right: 20%;\n  }\n  @media (min-width: 450px) {\n  .home {\n    display: none;\n  }\n  .cart{\n    position: relative;\n    left: 200%;\n  } \n  .hamsburg{\n    position: relative;\n    right: 20%;\n  }\n\n}\n}\n\n@media (max-width: 430px) {\n  .home {\n    display: none;\n  }\n  .cart{\n    position: relative;\n    left: 200%;\n  } \n  .hamsburg{\n    position: relative;\n    right: 20%;\n  }\n\n}\n\n\n@media (max-width: 748px) {\n\n  /* .cart{\n    position: relative;\n    left: 2px;\n  }\n  .hamsburg{\n    position: relative;\n    right: 30px;\n  } */\n  .card_name{\n    display:'none'\n  }\n}\n@media(max-width:666px){\n  .cart_items{\n    margin-top: 75px;\n  }\n}\n@media(max-width:1024px){\n  .card_name{\n   display:'none';\n  }\n  \n}\n\n@media(max-width:320px){\n  .cart_items{\n    margin-top: 65px;\n  }\n  .cart{\n    position: relative;\n    left: 170%;\n  } \n  .hamsburg{\n    position: relative;\n    right: 20%;\n  }\n}\n\n@media(max-width:415px){\n  .header-section{\n    margin-top: 130px;\n  }\n}\n@media (min-width: 992px) {\n  .content {\n    margin-top: -100px !important;\n    /* Ensure content starts right below navbar */\n    padding-top: 20px;\n    /* Just enough spacing for aesthetics */\n  }\n}\n\n@media (min-width: 903px) {\n  .button button {\n    font-size: \"10px\";\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
